<h2 mat-dialog-title>
  <mat-icon class="title-icon">extension</mat-icon>
  Configurar MCP de Bisual
</h2>

<mat-dialog-content cdkScrollable>
  <p class="intro">
    Conecta el servidor MCP de Bisual a tu cliente de IA. Tras añadirlo, el cliente pedirá autorizar con tu cuenta Bisual (OAuth).
  </p>

  <div class="mcp-url-row">
    <code class="mcp-url">{{ mcp_url }}</code>
    <button mat-icon-button type="button" matTooltip="Copiar URL" (click)="copyMcpUrl()">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>

  <section class="client-section">
    <div class="client-header">
      <h3>Cursor</h3>
      <p>Instalación con un clic vía deeplink.</p>
    </div>
    <div class="client-actions">
      <button mat-flat-button color="primary" type="button" (click)="openCursorInstall()">
        <mat-icon>add</mat-icon>
        Añadir a Cursor
      </button>
      <button mat-stroked-button type="button" (click)="copyCursorJson()">
        <mat-icon>content_copy</mat-icon>
        Copiar JSON
      </button>
    </div>
  </section>

  <section class="client-section">
    <div class="client-header">
      <h3>VS Code</h3>
      <p>Instalación con un clic (Copilot / Agent mode).</p>
    </div>
    <div class="client-actions">
      <button mat-flat-button color="primary" type="button" (click)="openVscodeInstall()">
        <mat-icon>add</mat-icon>
        Añadir a VS Code
      </button>
      <button mat-stroked-button type="button" (click)="copyVscodeJson()">
        <mat-icon>content_copy</mat-icon>
        Copiar JSON
      </button>
    </div>
  </section>

  <section class="client-section">
    <div class="client-header">
      <h3>Claude Code</h3>
      <p>Copia el comando y ejecútalo en una terminal (fuera de una sesión <code>claude</code>).</p>
    </div>
    <pre class="code-block">{{ claude_cli_command }}</pre>
    <div class="client-actions">
      <button mat-flat-button color="primary" type="button" (click)="copyClaudeCommand()">
        <mat-icon>content_copy</mat-icon>
        Copiar comando
      </button>
      <button mat-stroked-button type="button" (click)="copyClaudeJson()">
        <mat-icon>content_copy</mat-icon>
        Copiar JSON
      </button>
    </div>
  </section>

  <section class="client-section">
    <div class="client-header">
      <h3>ChatGPT</h3>
      <p>
        No hay instalación automática. Necesitas plan de pago, Developer mode activado y crear una app con la URL del MCP y autenticación
        OAuth (solo web).
      </p>
    </div>
    <ol class="chatgpt-steps">
      <li>Activa <strong>Developer mode</strong> en Settings → Apps / Security.</li>
      <li>Ve a Apps / Plugins → <strong>Create</strong>.</li>
      <li>Pega la URL del MCP, elige autenticación <strong>OAuth</strong> y crea la app.</li>
      <li>Completa el login de Bisual cuando lo pida.</li>
    </ol>
    <div class="client-actions">
      <button mat-flat-button color="primary" type="button" (click)="copyMcpUrl()">
        <mat-icon>content_copy</mat-icon>
        Copiar URL del MCP
      </button>
    </div>
  </section>

  <mat-accordion class="manual-accordion" multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Configuración manual · Cursor</mat-panel-title>
        <mat-panel-description>Archivo <code>.cursor/mcp.json</code></mat-panel-description>
      </mat-expansion-panel-header>
      <pre class="code-block">{{ cursor_manual_json }}</pre>
      <button mat-stroked-button type="button" (click)="copyCursorJson()">
        <mat-icon>content_copy</mat-icon>
        Copiar
      </button>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Configuración manual · VS Code</mat-panel-title>
        <mat-panel-description>Archivo <code>.vscode/mcp.json</code></mat-panel-description>
      </mat-expansion-panel-header>
      <pre class="code-block">{{ vscode_manual_json }}</pre>
      <button mat-stroked-button type="button" (click)="copyVscodeJson()">
        <mat-icon>content_copy</mat-icon>
        Copiar
      </button>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Configuración manual · Claude Code</mat-panel-title>
        <mat-panel-description>Archivo <code>.mcp.json</code> o <code>~/.claude.json</code></mat-panel-description>
      </mat-expansion-panel-header>
      <pre class="code-block">{{ claude_manual_json }}</pre>
      <button mat-stroked-button type="button" (click)="copyClaudeJson()">
        <mat-icon>content_copy</mat-icon>
        Copiar
      </button>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cerrar</button>
</mat-dialog-actions>
